const cards = [
  {
    id: 1,
    title: '剑与魔法',
    subtitle: '韩漫 · 奇幻冒险',
    tag: '热门连载',
    tagColor: 'bg-accent-100 text-accent-700',
    desc: '少年剑士在魔法世界中展开史诗冒险，画风华丽，剧情扣人心弦，韩漫奇幻类必读之作。',
    image: 'https://readdy.ai/api/search-image?query=A%20fantasy%20manhwa%20cover%20art%20style%20illustration%20featuring%20a%20young%20warrior%20with%20a%20sword%20in%20a%20magical%20world%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20dramatic%20lighting%2C%20detailed%20character%20design%2C%20Korean%20webtoon%20art%20style%2C%20clean%20composition%20on%20neutral%20cream%20background&width=800&height=600&seq=card-comic-01&orientation=landscape',
    stats: { views: '128万', chapters: '216话' },
  },
  {
    id: 2,
    title: '甜蜜陷阱',
    subtitle: '韩漫 · 恋爱甜宠',
    tag: '新番上线',
    tagColor: 'bg-primary-100 text-primary-700',
    desc: '霸道总裁与甜心设计师的浪漫故事，每话都让人心动不已，韩漫恋爱类人气TOP。',
    image: 'https://readdy.ai/api/search-image?query=A%20romantic%20manhwa%20illustration%20with%20a%20stylish%20couple%20in%20modern%20Seoul%20cityscape%2C%20soft%20pink%20and%20warm%20peach%20color%20tones%2C%20gentle%20lighting%2C%20delicate%20character%20art%2C%20Korean%20webtoon%20romance%20style%2C%20clean%20cream%20background&width=800&height=600&seq=card-comic-02&orientation=landscape',
    stats: { views: '96万', chapters: '89话' },
  },
  {
    id: 3,
    title: '暗夜追踪者',
    subtitle: '日漫 · 悬疑推理',
    tag: '高分推荐',
    tagColor: 'bg-secondary-100 text-secondary-700',
    desc: '天才侦探与神秘组织的智力对决，日本漫画悬疑类巅峰之作，分镜精妙绝伦。',
    image: 'https://readdy.ai/api/search-image?query=A%20mystery%20manga%20style%20illustration%20with%20a%20detective%20character%20in%20a%20dark%20urban%20alleyway%2C%20noir%20atmosphere%20with%20teal%20and%20charcoal%20color%20tones%2C%20dramatic%20shadows%2C%20clean%20Japanese%20manga%20art%20style%2C%20neutral%20cream%20background&width=800&height=600&seq=card-comic-03&orientation=landscape',
    stats: { views: '85万', chapters: '152话' },
  },
  {
    id: 4,
    title: '命运轮回',
    subtitle: '日漫 · 转生异世界',
    tag: '持续霸榜',
    tagColor: 'bg-accent-100 text-accent-700',
    desc: '转生到异世界的少年如何利用前世记忆逆天改命，日漫异世界题材的现象级作品。',
    image: 'https://readdy.ai/api/search-image?query=A%20isekai%20manga%20illustration%20with%20a%20hero%20in%20fantasy%20armor%20standing%20before%20a%20magical%20portal%2C%20vibrant%20emerald%20and%20gold%20color%20palette%2C%20epic%20fantasy%20atmosphere%2C%20Japanese%20manga%20art%20style%2C%20clean%20cream%20background&width=800&height=600&seq=card-comic-04&orientation=landscape',
    stats: { views: '203万', chapters: '340话' },
  },
  {
    id: 5,
    title: '星空物语',
    subtitle: '日漫 · 青春校园',
    tag: '治愈佳作',
    tagColor: 'bg-primary-100 text-primary-700',
    desc: '高中天文社的少男少女们在星空下编织的青春物语，画风清新温暖令人感动。',
    image: 'https://readdy.ai/api/search-image?query=A%20slice%20of%20life%20manga%20illustration%20with%20high%20school%20students%20under%20a%20starry%20night%20sky%2C%20soft%20lavender%20and%20warm%20amber%20color%20tones%2C%20gentle%20dreamy%20atmosphere%2C%20Japanese%20manga%20art%20style%2C%20clean%20cream%20background&width=800&height=600&seq=card-comic-05&orientation=landscape',
    stats: { views: '67万', chapters: '78话' },
  },
  {
    id: 6,
    title: '拳皇之路',
    subtitle: '韩漫 · 热血格斗',
    tag: '燃向必看',
    tagColor: 'bg-secondary-100 text-secondary-700',
    desc: '地下拳手一步步登顶世界格斗巅峰的传奇之路，动作场面张力十足令人热血沸腾。',
    image: 'https://readdy.ai/api/search-image?query=A%20fighting%20manhwa%20illustration%20with%20a%20muscular%20fighter%20in%20dynamic%20action%20pose%20in%20a%20boxing%20ring%2C%20intense%20red%20and%20orange%20color%20tones%2C%20dramatic%20spotlight%20effect%2C%20Korean%20webtoon%20action%20style%2C%20clean%20cream%20background&width=800&height=600&seq=card-comic-06&orientation=landscape',
    stats: { views: '156万', chapters: '198话' },
  },
  {
    id: 7,
    title: '末日生存指南',
    subtitle: '韩漫 · 末世生存',
    tag: '口碑爆棚',
    tagColor: 'bg-accent-100 text-accent-700',
    desc: '末日降临，普通上班族如何在残酷世界中生存并保护所爱之人，韩漫末世题材巅峰。',
    image: 'https://readdy.ai/api/search-image?query=A%20post%20apocalyptic%20manhwa%20illustration%20with%20a%20survivor%20in%20a%20ruined%20cityscape%2C%20muted%20olive%20and%20rust%20color%20tones%2C%20dramatic%20atmospheric%20lighting%2C%20Korean%20webtoon%20style%20with%20detailed%20backgrounds%2C%20clean%20cream%20background&width=800&height=600&seq=card-comic-07&orientation=landscape',
    stats: { views: '112万', chapters: '167话' },
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-16 md:py-22 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-end justify-between mb-12 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
              精选推荐
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              编辑精心挑选的高品质漫画作品
            </p>
          </div>
          <span className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium cursor-pointer whitespace-nowrap hover:text-primary-700 transition-colors">
            查看全部 <i className="ri-arrow-right-line"></i>
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cards.slice(0, 7).map((card) => (
            <div
              key={card.id}
              className={`bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all group cursor-pointer ${
                card.id === 1 ? 'sm:col-span-2 sm:row-span-1' : ''
              } ${card.id === 7 ? 'lg:col-span-2 xl:col-span-1' : ''}`}
            >
              <div className="relative overflow-hidden" style={{ aspectRatio: '16/10' }}>
                <img
                  src={card.image}
                  alt={`YY漫画推荐 - ${card.title}`}
                  title={`${card.title} - ${card.subtitle}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className={`px-2.5 py-1 rounded-md text-xs font-bold ${card.tagColor}`}>
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-lg text-foreground-900">{card.title}</h3>
                <p className="text-xs text-foreground-500 mt-1">{card.subtitle}</p>
                <p className="text-sm text-foreground-600 mt-2 line-clamp-2 leading-relaxed">
                  {card.desc}
                </p>
                <div className="flex items-center gap-4 mt-3 pt-3 border-t border-background-200/60">
                  <span className="text-xs text-foreground-500">
                    <i className="ri-eye-line mr-1"></i>{card.stats.views}
                  </span>
                  <span className="text-xs text-foreground-500">
                    <i className="ri-file-list-3-line mr-1"></i>{card.stats.chapters}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}